import React from 'react';
import { CnPlaceholder } from '@alife/cn-ui';
import "./index.scss";
export function Placeholder(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cn-lowcode-page-placeholder-wrapper"
  }, /*#__PURE__*/React.createElement(CnPlaceholder, {
    className: "cn-lowcode-page-placeholder"
  }, " "), /*#__PURE__*/React.createElement("div", {
    className: "cn-lowcode-page-placeholder-cnt"
  }, children));
}